module.exports = [{"id":1,"name":"home-page.html","listName":"mainBody","creatorPath":"/","pageTranslationKey":"Pag_Home"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/defSites.json
// module id = 67
// module chunks = 0